export default __webpack_public_path__ + "images/product--prescription.svg?4acaf597ee89f6c3ef6bb900c8601215";